<!--테스트 
단일 상품(고무영, 홍씨네 구입) : http://localhost:7777/checkout?product_id=2192&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJfbm8iOiIxNjQxMjY0MjM4MzQ1IiwiZW1haWwiOiIiLCJuYW1lIjoi6rOg66y07JiBIiwidHlwZSI6InBob25lIiwicHJvZmlsZSI6Im1lZGlhLzE2NDEyNjQyMzgzNDUvMTI0NDMuanBnIiwidXNlcl90eXBlIjoi7J2867CYIiwiaWF0IjoxNjQ4MTc2NzIwLCJleHAiOjE3MzQ1NzY3MjAsImlzcyI6Ii5vaC1iYWIuY29tIiwic3ViIjoidXNlckluZm8ifQ.1EaU5IYBFO4wuFLhqBQ6mczM55RV1N_HyQhGEfin5Jg
멀티 상품(고무영, 홍씨네 구입) : http://localhost:7777/checkout?product_id=1493,54344&qty=3,4&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJfbm8iOiIxNjQxMjY0MjM4MzQ1IiwiZW1haWwiOiIiLCJuYW1lIjoi6rOg66y07JiBIiwidHlwZSI6InBob25lIiwicHJvZmlsZSI6Im1lZGlhLzE2NDEyNjQyMzgzNDUvMTI0NDMuanBnIiwidXNlcl90eXBlIjoi7J2867CYIiwiaWF0IjoxNjQ4MTc2NzIwLCJleHAiOjE3MzQ1NzY3MjAsImlzcyI6Ii5vaC1iYWIuY29tIiwic3ViIjoidXNlckluZm8ifQ.1EaU5IYBFO4wuFLhqBQ6mczM55RV1N_HyQhGEfin5Jg

쿠폰 상품 : http://localhost:7777/checkout?product_id=12758&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJfbm8iOiIxNjQyNDcwMTczMjQzIiwiZW1haWwiOiIiLCJuYW1lIjoi7J2867CY7IKs7Jqp7J6QIiwidHlwZSI6InBob25lIiwicHJvZmlsZSI6Im1lZGlhLzE2NDI0NzAxNzMyNDMvMTE2Mi5qcGciLCJ1c2VyX3R5cGUiOiLsnbzrsJgiLCJpYXQiOjE2NDI2NDA3NDUsImV4cCI6MTcyOTA0MDc0NSwiaXNzIjoiKiIsInN1YiI6InVzZXJJbmZvIn0.3gs1I0R92b5PYyrnOFF7xaVH6Vm6PsR9Yxz0pd53V7w
쿠폰 아닌 상품 : http://localhost:7777/checkout?product_id=12768&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJfbm8iOiIxNjQyNDcwMTczMjQzIiwiZW1haWwiOiIiLCJuYW1lIjoi7J2867CY7IKs7Jqp7J6QIiwidHlwZSI6InBob25lIiwicHJvZmlsZSI6Im1lZGlhLzE2NDI0NzAxNzMyNDMvMTE2Mi5qcGciLCJ1c2VyX3R5cGUiOiLsnbzrsJgiLCJpYXQiOjE2NDI2NDA3NDUsImV4cCI6MTcyOTA0MDc0NSwiaXNzIjoiKiIsInN1YiI6InVzZXJJbmZvIn0.3gs1I0R92b5PYyrnOFF7xaVH6Vm6PsR9Yxz0pd53V7w
-->
 
<!-- 원본 보존
<template>
    <section>
        <div v-if="!success">
            <h1>주문 페이지</h1>
            <div>주문번호 : {{order_id}}</div>
            <div>상품번호 : {{product_id}}</div>
            <div>상품명 : {{product_name}}</div>
            <div>가격 : {{price}}</div>
            <div>수량 : {{qty}}</div>
            <div>이름 : {{name}}</div>
            <div>전화번호 : {{phone}}</div>
            <div>주소 : {{road_address_name}}</div>
            <div>상세 주소 : {{address_detail}}</div>
            <div>우편번호 : {{post}}</div>
            <div>배송비 : {{shipping}}</div>
            <div>최종가격 : {{amount}}</div>
            
            <div @click="openDaumPostCode()">[주소 변경]</div>
            <div @click="order()">[주문]</div>

            <DaumPostCode :open="showDaumPostCode" @selected="onAddressSelected" />
        </div>
        <loading v-show="loading"/>
    </section>
</template>
 원본 보존 -->

 <template>
  <section class="mobile_wrap">
    <div v-if="!success">
      <div v-if="shahbet && profiles.length > 0" class="order__shahbet__profile">
        <p>계정 선택</p>
        <select v-model="selected_id" class="shahbet_profile_select">
          <option value="0" disabled>계정을 선택해주세요</option>
          <option
            v-for="profile in profiles"
            :key = "profile.id"
            :value = "profile.id"
          > {{ profile.nickname }} ({{ profile.id }})
          </option>
        </select>
      </div>
      <div class="order__content">
        <div class="order__details">
          <p>주문내역</p>
          <ul class="product_list">
            <!-- 닉데이터가 구매한 유저 인지 판매하는 유저인지 모르겠음 -->
            <li class="product_name">{{ seller_name }}</li>
            <!-- 반복 -->
            <li v-for="(item, index) in products" :key="index">
              <h3>{{ item.name }}</h3>
              <dl class="item_subinfo">
                <dd>
                  주문수량
                  <div class="count">
                    <button @click="onQty('decrease', item)">
                      -
                      <!-- <i class="decrease"/> -->
                    </button>
                    <!-- <p>{{ item.qty }}</p> -->
                    <p>
                      <input type="number" pattern="\\d*" :value="item.qty" @change="onQty('input', item, $event)"/>
                    </p>
                    <button @click="onQty('increase', item)">
                      +
                      <!-- <i class="increase"/> -->
                      <!-- <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><image x="10.667" y="10.667" width="10.667" height="10.667" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABGdBTUEAALGN5fIAKQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAJKADAAQAAAABAAAAJAAAAAAJxsHGAAABBklEQVRYCe2WYQ7CIAyFhwdyMeFCO5kXIjHzQlgSaQgrPLRT/tQ/I31d+/lg65bFfn0HXF/uq977m3PuHmO8pkxaP2m9hRAe/Tvb6qUtYeUNs1Jm+mOOYNYUw3e2M1RA2ZmyvBQrdbRWAVFxaculGOJgXQvEhc5aGBBy0hwyh5ADSLczhBzit2o1KDmOCij1WA9k3rJqUCr7DN9+GMgMpB2KwwhCYtmbgYS8KSEGSns5hYCalr0ZiGzbSNhJj38ES4d6T71zT9XTRE+mCE+fsF/XZYcy4eyrAaEdMIfMIeQA0u0M/doh6U0txRAH66otK4dirijFsjZyVQFVA/kwKEcALOdTB16QMFM+B1B/tAAAAABJRU5ErkJggg==" transform="translate(-10 -10)" fill="none" fill-rule="evenodd"/></svg> -->
                    </button>
                  </div>
                </dd>
                <dd>금액 : {{ item.ui__price.toLocaleString("ko-KR") }}원</dd>
              </dl>
            </li>
            <!-- 반복 -->
          </ul>
        </div>
        <div class="order__receipt">
          <p>수령방법</p>
          <dl>
            <dd>
              <input
                id="delivery"
                value="delivery"
                name="order_receipt"
                type="radio"
                :checked="delivery == 'delivery'"
                :disabled="delivery_option == '배송안함'"
                @click="changeValue"
              />
              <label for="delivery">
                <i />
                <span>{{
                  delivery_option == "배송안함" ? "배송 불가" : "배달 요청"
                }}</span>
              </label>
            </dd>
            <dd>
              <input
                id="direct"
                value="direct"
                name="order_receipt"
                type="radio"
                :checked="delivery == 'direct'"
                :disabled="delivery_option == '픽업안함'"
                @click="changeValue"
              />
              <label for="direct">
                <i />
                <span>{{
                  delivery_option == "픽업안함" ? "픽업 불가" : "직접 픽업"
                }}</span>
              </label>
            </dd>
          </dl>
        </div>

        <div v-if="delivery == 'direct'" class="delivery__info">
          <dl>
            <dd>픽업 주소</dd>
            <dd></dd>
          </dl>
          <div class="delivery__address">
            {{
              start_address.road_address_name
                ? start_address.road_address_name
                : start_address.address_name
            }}, {{ start_address.address_detail }}
            {{
              start_address.place_name ? `(${start_address.place_name})` : ""
            }}
          </div>
          <!-- <dl class="delivery__price">
                        <dd>배송비</dd>
                        <dd><span>{{shipping.toLocaleString('ko-KR')}}</span>원</dd>
                    </dl> -->
        </div>

        <div v-if="delivery == 'delivery'" class="delivery__info">
          <dl>
            <dd>주소</dd>
            <dd>
              <button @click="openDevilAddressSelect()">배송지 목록</button>
              &nbsp;
              <button @click="openDevilAddressSearch()">주소 입력/수정</button>
            </dd>
          </dl>
          <div class="delivery__address">
            <dl>
              <dd>받는분:</dd>
              <dd>
                <input
                  :value="checkout_name"
                  @input="changeName"
                  type="text"
                  placeholder="받는 분을 입력해 주세요."
                />
              </dd>
            </dl>
            <dl>
              <dd>연락처:</dd>
              <dd>
                <input
                  v-model = "checkout_number"
                  type="text"
                  placeholder="연락처를 입력해 주세요."
                />
              </dd>
            </dl>
            {{ address_text }}
          </div>
          <!-- <dl class="delivery__price">
                        <dd>배송비</dd>
                        <dd><span>{{shipping.toLocaleString('ko-KR')}}</span>원</dd>
                    </dl> -->
        </div>
        <div class="coupon__select">
          <p>쿠폰 사용</p>
          <div v-if="coupons.length == 0" class="coupon_select disabled">
            사용가능한 쿠폰이 없습니다.
            <i class="icon angle-down" />
          </div>
          <div v-else class="coupon_select" @click="on_select('coupon')">
            {{
              coupon
                ? `${coupon.name} - ${coupon.price.toLocaleString("ko-KR")}${
                    coupon.price_type == "absolute" ? "원" : "%"
                  }`
                : "사용 가능 쿠폰 " + coupons.length + "장"
            }}
            <i class="icon angle-down" />
          </div>
          <div class="saved__money">
            <p>
              {{
                coupons && coupons.filter(f=>f.coupon_id==55054).length > 0 ?
                '나눔 1회를 통해 적립된 500CRC으로 500원 할인(쿠폰과 중복 불가)' : ''
              }}
            </p>
          </div>
          <div>
          <p class="star">1만원권 쿠폰 사용 시 미사용 잔여 금액은 별도로 누적되지 않습니다.</p>
          </div>
        </div>

        <div class="coupon__select" v-if="ui_spoon_display">
          <p>CRC</p>
          <div class="saved__money">
            <div class="saved_money">
              <input
                v-bind:value="use_spoon"
                v-on:input="updateSpoon"
                type="number"
                placeholder="0"
              />
              <button @click="on_spoon">모두사용</button>
            </div>
            <p>
              보유
              <span>{{ spoon.toLocaleString("ko-KR") }}
                CRC
                <!-- <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg"><path d="m5.442 6.69.497.491-.39.394a.786.786 0 0 1-.12.958L2.352 11.61a.786.786 0 0 1-1.115 0l-.219-.219a.786.786 0 0 1 0-1.114l3.077-3.078a.786.786 0 0 1 .959-.12l.388-.39ZM2.639 0l2.43 2.436c.632.634.726 1.627.224 2.368L6.31 5.822l.495.496.758.757a.788.788 0 0 1 .958.12l3.078 3.078a.79.79 0 0 1 0 1.115l-.22.219a.788.788 0 0 1-1.116 0L7.198 8.53a.79.79 0 0 1-.123-.959l-2.278-2.27c-.742.5-1.733.406-2.368-.224L0 2.652l.496-.498 2.429 2.428a1.165 1.165 0 0 0 1.648-1.648L2.143.503 2.64 0Zm8.882 1.095c.34.37.512.864.474 1.365-.05.939-1.007 3.001-2.444 3.54-.223.087-.46.132-.698.133a2.086 2.086 0 0 1-1.338-.524l-.337.337-.496-.495.338-.338c-.647-.802-.573-1.546-.38-2.048.547-1.426 2.588-2.39 3.516-2.442.501-.04.996.13 1.365.472Zm-1.248.23h-.077c-.747.04-2.485.916-2.902 1.993-.206.533-.053 1.043.458 1.56.512.517 1.011.67 1.55.467 1.084-.408 1.953-2.167 1.993-2.921a1.11 1.11 0 0 0-.27-.833 1.077 1.077 0 0 0-.752-.266ZM1.568 1.08l2.355 2.355-.496.496-2.355-2.355.496-.496Z" fill="#F2632A" fill-rule="nonzero"/></svg> -->
              </span>
            </p>
            <div
              class="spoon_info"
              v-if="not_only_shahbet"
            >
              <p>
                현재 적용 가능 <span>{{ (max_spent + spent >= 0 ? (this.spoon >= max_spent + spent?(((max_spent + spent) >= max_use_per_item*products.length)? (max_use_per_item*products.length > this.amount ? this.amount : max_use_per_item*products.length) : max_spent + spent):this.spoon):0).toLocaleString("ko-KR") }} CRC</span>
              </p>
              <p>
                하루 최대 20,000 CRC , 주문 품목당 최대 5,000 CRC 사용 가능합니다.
              </p>
            </div>
          </div>
        </div>
        

        <div class="payment__select">
          <!--
                      <p>결제수단</p>
                      <div class="payment_select">
                        신용/체크카드
                    </div>
                    결제수단 여러개 일떄
                    <div class="payment_select" @click="on_select">
                        {{selectData}}
                        <i class="icon angle-down"/>
                    </div> 
                    -->

          <!-- <div v-if="selectData == '예치금 차감'" class="payment__money">
                        <dl>
                            <dd>
                              <p>현재 예치금 잔액</p>
                              <p>차감 후 잔액</p>
                            </dd>
                            <dt>
                              <p>{{point.toLocaleString('ko-KR')}}원</p>
                              <p>{{(point-amount).toLocaleString('ko-KR')}}원</p>
                            </dt>
                        </dl>
                    </div> -->

          <div class="payment__money">
            <dl>
              <dd>
                <p>주문금액</p>
                <p>배송비</p>
                <p v-if="ui_spoon_display">CRC할인</p>
                <p>쿠폰할인</p>
              </dd>
              <dt>
                <p>
                  <span>{{ products__price.toLocaleString("ko-KR") }}</span
                  >원
                </p>
                <p>
                  <span>{{ shipping.toLocaleString("ko-KR") }}</span
                  >원
                </p>
                <p v-if="ui_spoon_display">
                  <span>{{ use_spoon.toLocaleString("ko-KR") }}</span
                  >원
                </p>
                <p>
                  <span>{{ coupon_price_text }}</span
                  >원
                </p>
              </dt>
            </dl>
          </div>
        </div>
        <ul class="agree__list">
          <li>
            <input
              id="agree1"
              type="checkbox"
              value="agree1"
              v-model="checkedValues"
            />
            <label for="agree1"
              ><i />배달상품 주의사항 &nbsp;
              <a href="/html/member/agree5.html">[보기]</a></label
            >
          </li>
          <li>
            <input
              id="agree2"
              type="checkbox"
              value="agree2"
              v-model="checkedValues"
            />
            <label for="agree2"
              ><i />개인정보제3자제공동의 &nbsp;
              <a href="/html/member/agree1.html">[보기]</a></label
            >
          </li>
        </ul>
      </div>
      <div class="order__footer">
        <p>
          총 <span>{{ amount.toLocaleString("ko-KR") }}</span
          >원
        </p>
        <button @click="order()">결제하기</button>
      </div>
    </div>
    <loading v-show="loading" />
    <div v-if="isSelect" class="selectBg" @click="on_select">
      <ul>
        <li
          v-for="(item, index) in selects"
          :key="index"
          @click="on_select_data(item)"
        >
          <span v-bind:class="{ active: item == selectData }">{{
            item.name
          }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import client from "../client/client";
import { PGS, CRC_MAX_SPENT, CRC_MAX_USE_PER_ITEM } from "../order/constants";
import Utils from "../order/utils";
import Loading from "../components/Loading";
import DaumPostCode from "../components/DaumPostCode";
import { importId } from "../order/importpay";
import { useRoute } from 'vue-router'

export default {
  name: "Checkout",
  components: {
    Loading,
    DaumPostCode,
  },
  data: function () {
    const route = useRoute()
    const { query } = route;
    return {
      // shahbet
      shahbet: false,
      not_only_shahbet: false,
      profiles: [],
      selected_id: 0,
      selected_nickname: "",

      loading: true,
      success: false,
      query: query,
      initialMerchantUid: `mid_${new Date().getTime()}`,
      pgs: PGS,
      methods: Utils.getMethodsByPg(),
      quotas: Utils.getQuotaByPg(),
      initialMethod: "card",
      vbankDueVisible: false,
      bizNumVisible: false,
      quotaVisible: true,
      address_text:'',
      seller_name:'',

      showDaumPostCode: false,
      phone: "",
      name: "",
      address: {},
      shipping: "",
      amount: "",
      products__price: "",

      products: [],
      order_id: "",
      delivery: "delivery",
      delivery_option: "1단계",
      start_address: {},

      //스푼
      ui_spoon_display: true,
      spoon: 0,
      max_spent: CRC_MAX_SPENT,
      max_use_per_item: CRC_MAX_USE_PER_ITEM,
      use_spoon: 0,
      use_all_spoon: false,
      spent: 0,

      //예치금 잔액
      point: 0,
      use_point: 0,
      use_all_point: false,

      // 체크
      checkedValues: [],

      // 셀렉트
      selectType: "",
      selectData: "신용/체크카드",
      selects: [],
      isSelect: false,
      checkout_name:'',
      checkout_number:'',

      // 쿠폰
      dc:0,
      coupon:null,
      coupon_price_text: "0",
      coupons: [
      ],

      // 유입경로
      from:''
    };
  },
  methods: {
    //shahbet
    checkShahbetProducts(){
      let shahbet_products = this.products.filter(prod => ['패키지상품','오토쉽상품','정회원판권'].includes(prod.product_category));
      this.shahbet_products = shahbet_products; //for testing delete with logs
      this.shahbet = shahbet_products.length > 0;
      
      this.updatePaymentAmount();
    },
    checkOnlyShahbetProducts(){
      let not_shahbet_products = this.products.filter(prod => !(['패키지상품','오토쉽상품','정회원판권'].includes(prod.product_category)));
      this.not_only_shahbet = not_shahbet_products.length > 0;
    },
    //get shahbet profiles
    async fetchProfiles(){
      // Only proceed if we have shahbet products
      if (!this.shahbet) {
        return;
      }
      try{
        const data = await client.get(`/api/order/shahbet/profiles?phone=${this.phone}`);
        if(data && data.profiles){
          this.profiles = data.profiles;
        }
      } catch(err){
        console.error('Fetch error: ', err);
      }
    },
    //인풋 네임 변경
    changeName(e) {
      this.checkout_name = e.target.value;
    },
    //주문수량
    async onQty(type, item, event) {
      if (type == "increase") {
        item.qty = parseInt(item.qty) + 1;
        item.ui__price = item.price * item.qty;
        this.updatePaymentAmount();
        return;
      } else if (type == "decrease") {
        if (item.qty > 1) {
          item.qty = parseInt(item.qty) - 1;
          item.ui__price = item.price * item.qty;
          this.updatePaymentAmount();
        } else {
          alert("주문 가능한 최소\n수량은 1개 입니다.");
        }
        return;
      } else if(type == "input") {
        if(event.target.value.length == 0) {
          event.target.value = 1;
          item.qty = 1;
          item.ui__price = item.price * item.qty;
          this.updatePaymentAmount();
          alert("주문 가능한 최소\n수량은 1개 입니다.");
        } if(item.qty >=  1) {
          item.qty = parseInt(event.target.value);
          item.ui__price = item.price * item.qty;
          this.updatePaymentAmount();
        } else {
          alert("주문 가능한 최소\n수량은 1개 입니다.");
          item.qty = 1;
          item.ui__price = item.price * item.qty;
          this.updatePaymentAmount();
        }
        return;
      }
    },
    //라디오
    changeValue(event) {
      this.delivery = event.target.value;
      this.updatePaymentAmount();
    },
    //셀렉트 박스
    on_select(type) {
      this.selectType = type;
      this.isSelect = !this.isSelect;
      if (type == "coupon") {

        this.selects = this.coupons.map((m) => ({
          id: m.id,
          name: `${m.name} - ${m.price.toLocaleString("ko-KR")} ${
            m.price_type == "absolute" ? "원" : "%"
          }`,
        }));
      }
    },
    on_select_data(item) {
      if (this.selectType == "payment") {
        this.selectData = item;
      } else if (this.selectType == "coupon") {
        this.coupon = this.coupons.filter((f) => f.id == item.id)[0];
        this.updatePaymentAmount();
      }
    },
    //포인트
    updateSpoon(event) {
      if(this.not_only_shahbet) {
        if(this.spent < CRC_MAX_SPENT) {
          let left_max = CRC_MAX_SPENT + this.spent; // 하루 최대 사용량 + 오늘 사용량(음수)
          let product_max = this.products.length * CRC_MAX_USE_PER_ITEM;
          let use_max = left_max > product_max? product_max : left_max;
          this.use_spoon = event.target.value >= use_max ? use_max : event.target.value;
          this.use_all_spoon = false;
        } else {
          this.use_spoon = 0;
          this.use_all_spoon = false;
        }
      } else {
        this.use_spoon = event.target.value;
        this.use_all_spoon = false;
      }
      this.updatePaymentAmount();
    },
    on_spoon() {
      this.use_all_spoon = !this.use_all_spoon;
      this.updatePaymentAmount();
    },
    async update() {
      this.loading = true;
      const route = useRoute()
      const { query } = route;
      client.updateToken(query);

      let product_ids = query.product_id.split(",");
      this.from = query.from

      let qtys = [];
      if (query.qty) qtys = query.qty.split(",");

      for (let i = 0; i < product_ids.length; i++) {
        let product = await client.get(`/api/product/detail/${product_ids[i]}`);
        delete product.brandOtherProducts;
        this.products.push(product);
        product.qty = i < qtys.length ? parseInt(qtys[i]) : 1;
        product.ui__price = product.price * product.qty;

        if (product.status && product.status != "판매중") {
          alert(`${product.name}은 현재 판매중이 아닙니다`);
          window.location.href = "jevil://devil.com/back";
          return;
        }
      }

      this.start_address = this.products[0].start_address;
      this.seller_name = this.products[0].start_address.name;

      this.ui_spoon_display = true;

      let my = await client.get(`/api/my`);
      let address_res = await client.get(`/api/order/address/list?type=default`);

      this.phone = my.phone;
      this.name = my.name;
      this.point = my.point;

      if(this.ui_spoon_display) {
        this.spoon = parseInt(my.spoon);
      }

      if(address_res && address_res.list && address_res.list.length > 0) {
        this.address = address_res.list[0] 
        this.updateAddress();
      } else if (my.road_address_name || my.address_name) {
        this.address = {
          name: this.name,
          phone: this.phone,
          road_address_name: my.road_address_name,
          address_name: my.address_name,
          address_detail: my.address_detail,
          place_name: my.place_name,
          address_x: my.address_x,
          address_y: my.address_y,
        };
        this.updateAddress();
      } else {
        this.address_text = "지정된 배송지가 없어요.\n배송지를 입력해주세요.";
      }
      

      this.delivery_option = this.products[0].delivery_option;
      if (this.delivery_option == "배송안함") this.delivery = "direct";
      if (this.delivery_option == "픽업안함") this.delivery = "delivery";

      let coupon_res = await client.get(
        `/api/order/coupon/available?product_id=${query.product_id}`
      );

      this.coupons = coupon_res.list;

      let spoon_res = await client.get('/api/get/spoon/spent') // "환불"과 "구매 소진" 타입의 스푼 사용량 합산 조회 ( 구매 소진 음수, 환불 양수)
      if(spoon_res && spoon_res.spent) {
        this.spent = spoon_res.spent; // 오늘 하루 사용량이 -20000 일 경우 최대까지 사용한 것. spent는 양수일 수 없다
      }

      // this.coupons = [{
      //     name:'(가입축하) 사업주 제품 5% 할인',
      //     desc:'10,000원 이상 구매 시, 최대 할인금액 5,000원',
      //     date:'2021-05-05 ~ 2022-05-31',
      //     range_type:'each',
      //     price_type:'percent',
      //     shipping_check : true
      //     price:100,
      //     max_price:1000
      // }]

      this.host = window.location.protocol + "//" + window.location.host;

      this.loading = false;
    },
    async updateAddress() {
      if (this.address.road_address_name || this.address.address_name) {
        let address = this.address;
        let address_text = "";
        address_text += address.place_name? "(" + address.place_name + ") ": "";
        address_text += address.road_address_name? address.road_address_name: address.address_name;
        address_text += " " + address.address_detail;
        // address_text += ` ${this.address.name} ${this.address.phone}`;
        this.checkout_name = this.address.name;
        this.checkout_number = this.address.phone;
        this.address_text = address_text
      }
    },
    async couponPriceTypeCheck() {
      this.dc = 0;
      if(!this.coupon.range_type)
        this.coupon.range_type = 'each'
      if(!this.coupon.max_price)
        this.coupon.max_price = 100000

      if(this.coupon.range_type == 'each') {
        const coupon_products = this.coupon.products;
        let highest_product_price = 0
          this.products.map(m=>{
              coupon_products.map(product => {
                if(product.id == m.id && highest_product_price < m.price) {
                  highest_product_price = m.price * m.qty;
                  if(highest_product_price > this.coupon.max_price)
                    highest_product_price = this.coupon.max_price
                }
              })
        })

        let base_price = highest_product_price
        if (this.coupon.price_type == "percent") {
          this.dc = parseInt((base_price * this.coupon.price) / 100);  
        } else if (this.coupon.price_type == "absolute") {
          this.dc = this.coupon.price;
        }
        if(this.dc > this.coupon.max_price)
          this.dc = this.coupon.max_price
        if(this.dc > base_price)
          this.dc = base_price
      } else {
        let base_price = this.products__price
        
        if (this.coupon.price_type == "percent") {
          this.dc = parseInt((base_price * this.coupon.price) / 100);
          if(this.dc > this.coupon.max_price)
            this.dc = this.coupon.max_price
        } else if (this.coupon.price_type == "absolute") {
          this.dc = this.coupon.price;
        }
        if(this.dc > base_price)
          this.dc = base_price
      }

      if(this.coupon.shipping_check)
        this.dc += this.shipping
    },
    async updatePaymentAmount() {
      // 샤베트 상품( 패키지상품, 오토쉽상품, 정회원판권 카테고리 포함 시) 배송비 무료
      // 이외 일괄 3500원 부과
      if (this.shahbet) {
        this.shipping = 0;
      } else {
        this.shipping = 3500;
      }

      this.amount = 0;
      this.products__price = 0;
      this.dc = 0;

      //제품 금액 합산
      this.products.map((product) => {
        this.amount += product.price * product.qty;
        this.products__price += product.price * product.qty;
      });

      //쿠폰
      if (this.coupon) {
        this.couponPriceTypeCheck();
        let discount = this.dc;

        this.coupon_price_text = this.dc.toLocaleString("ko-KR");
        this.amount += this.shipping;
        if(this.amount < this.dc){
          discount = this.amount
          this.amount = 0;
        } 
        this.amount -= discount;
        this.coupon.discount = discount
      } else {
        this.amount += this.shipping;
      }

      
      let left_max = (CRC_MAX_SPENT + this.spent) > 0? CRC_MAX_SPENT + this.spent : 0; // 오늘 하루 사용량이 -20000 일 경우 최대까지 사용한 것. spent는 양수일 수 없다
      let product_max = this.products.length * CRC_MAX_USE_PER_ITEM;
      let use_max = left_max > product_max? product_max : left_max;

      if(this.not_only_shahbet) {
        if (this.use_all_spoon) { //모두 사용의 경우 최대 사용 가능 금액 계산
          if(use_max >= this.amount) {
            this.use_spoon = this.amount;
          } else {
            this.use_spoon = use_max;
          }
        } else {
          if(this.use_spoon >= use_max) { //사용가능 최대치 이상 사용하려고 하는 경우
            if(use_max >= this.amount) { //사용가능 최대치가 결제금액 이상이면 결제금액만큼 사용
              this.use_spoon = this.amount;
            } else { //사용가능 최대치가 결제금액 미만이면 사용가능 최대치만큼 사용
              this.use_spoon = use_max;
            }
          } else { //사용가능 최대치 미만 사용하려고 하는 경우
            this.use_spoon = this.use_spoon;
          }
        }
      } else { //샤베트 상품 구매시 포인트 사용
        if (this.use_all_spoon) { //모두 사용의 경우 최대 사용 가능 금액 계산
          if(this.spoon >= this.amount) {
            this.use_spoon = this.amount;
          } else {
            this.use_spoon = this.spoon; // 현재 포인트 사용
          }
        } else {
          if(this.use_spoon >= this.amount) { // 현재 포인트 사용 금액이 포인트 잔액 이상인 경우
            if(this.amount >= this.spoon) {
              this.use_spoon = this.spoon;
            } else {
              this.use_spoon = this.amount;
            }
          } else { // 현재 포인트 사용 금액이 포인트 잔액 미만인 경우
            if(this.use_spoon >= this.spoon) {
              this.use_spoon = this.spoon;
            } else {
              this.use_spoon = this.use_spoon;
            }
          }
        }
      }
      if(this.use_spoon >= this.spoon) this.use_spoon = this.spoon;
      this.amount -= this.use_spoon;
    },
    openDevilAddressSelect() {
      //this.showDaumPostCode = true
      window.location.href = "jevil://devil.com/popupAddressSelect";
    },
    async addressSelectPopupCallback(address_id) {
      //callback
      let res = await client.get(`/api/order/address/detail/` + address_id);
      if (res && res.r) {
        this.address = res.address;
        this.updateAddress();
        this.updatePaymentAmount();
      }
    },
    openDevilAddressSearch() {
      //this.showDaumPostCode = true
      window.location.href = "jevil://devil.com/popupAddress";
    },
    async addressPopupCallback(
      address_name,
      road_address_name,
      address_place_name,
      address_detail,
      address_post,
      address_x,
      address_y
    ) {
      //callback
      this.address = {
        name: this.name,
        phone: this.phone,
        address_name,
        road_address_name,
        address_place_name,
        address_detail,
        address_post,
        address_x,
        address_y,
      };

      this.updateAddress();
      this.updatePaymentAmount();
    },
    async order(e) {
      if(this.checkout_name != this.address.name || this.checkout_number != this.address.phone){
        this.address.name = this.checkout_name;
        this.address.phone = this.checkout_number + '';

        this.updateAddress();
        this.updatePaymentAmount();
      }
      
      if (!this.address.address_detail && this.delivery == "delivery") {
        alert("주소를 입력해주세요");
        return;
      } else if (this.checkedValues.length < 2) {
        alert("항목에 동의해주세요.");
        return;
      }

      if (this.amount > 0 && this.amount < 100) {
        alert(
          "예치금 제외하고, 결제액 100원 미만은 카드 결제는 불가합니다. 예치금을 조정하거나 결제금을 높여주세요"
        );
        return;
      }

      this.loading = true;

      let order = await client.post(`/api/order/start`, {
        type: "상품",
        amount: this.amount,
        phone: this.phone,
        name: this.name,
        // phone: this.checkout_number,
        // name: this.checkout_name,
        address: this.address,
        shipping: this.shipping,
        delivery: this.delivery,
        products: this.products,
        coupon: this.coupon,
        point: this.use_point,
        spoon: this.use_spoon,
        from : this.from,
        selected_id: this.selected_id,
        selected_nickname: this.selected_nickname
      });

      if (order && !order.r) {
        alert(order.msg);
        return;
      }

      if (!order || !order.order_id) {
        alert("일시적 오류가 발생하였습니다. 잠시 후 다시 시도해주세요");
        return;
      }

      if (this.amount == 0) {
        window.location.href =
          this.host +
          "/checkout/complete?success=true&impSuccess=true&merchant_uid=" +
          order.order_id;
        return;
      }

      const { IMP } = window;
      IMP.init(importId);
      const data = {
        pg: "html5_inicis",
        pay_method: "card",
        escrow: false,
        merchant_uid: order.order_id,
        name: order.order_name,
        amount: order.amount,
        buyer_name: this.name,
        // buyer_tel: this.phone,
        buyer_tel: this.checkout_number,
        buyer_email: "",
        buyer_addr: `${this.address_text}`,
        buyer_postcode: this.address.address_post,
        niceMobileV2: true,
        // app_scheme:'todaymeal',
        m_redirect_url: this.host + "/checkout/complete",
      };

      if (data.payMethod === "card") {
        data.display = {
          card_quota: 0,
        };
      }
      IMP.request_pay(data, this.callback);
      this.loading = false;
    },
    callback(response) {
      alert(response);
    },
  },
  watch: {
    // selected_id 값이 변경될 때마다 nickname 업데이트
    selected_id(newVal) {
      if (newVal && newVal !== 0) {
        const selectedProfile = this.profiles.find(profile => profile.id === newVal);
        if (selectedProfile) {
          this.selected_nickname = selectedProfile.nickname;
          console.log('Selected profile:', newVal, this.selected_nickname);
        }
      }
    }
  },
  async mounted() {
    await this.update();
    this.checkShahbetProducts(); // Now call after products are loaded
    this.checkOnlyShahbetProducts();
    this.fetchProfiles();
    window.addressPopupCallback = this.addressPopupCallback;
    window.addressSelectPopupCallback = this.addressSelectPopupCallback;
    var checkPageShow = false;
    window.onpageshow = function (event) {
        checkPageShow = true;
        if (event.persisted || (window.performance && window.performance.navigation.type == 2)) {
            window.location.reload();
        }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/icon.scss";
.mt12{
  margin-top:12px !important;
}
body {
  background-color: #eee !important;
}

.count {
  display: flex;
  margin-left: 10px;
  button,
  p {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 !important;
    background: #fff;
    border: 1px solid #e9e9e9;
    &:nth-child(2) {
      width: 52px;
    }
    input {
      border: 0;
      width: 100%;
      text-align: center;
      outline: none;
    }
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
  }
  p {
    border-left: 0;
    border-right: 0;
  }
  button {
    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .decrease {
    display: block;
    width: 12px;
    height: 2px;
    background-size: cover;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='2' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='10.667' y='15' width='10.667' height='2' rx='.75' transform='translate(-10 -15)' fill='%23343434' fill-rule='evenodd'/%3E%3C/svg%3E");
  }
  .increase {
    display: block;
    width: 12px;
    height: 12px;
    background-size: cover;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cimage x='10.667' y='10.667' width='10.667' height='10.667' xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABGdBTUEAALGN5fIAKQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAJKADAAQAAAABAAAAJAAAAAAJxsHGAAABBklEQVRYCe2WYQ7CIAyFhwdyMeFCO5kXIjHzQlgSaQgrPLRT/tQ/I31d+/lg65bFfn0HXF/uq977m3PuHmO8pkxaP2m9hRAe/Tvb6qUtYeUNs1Jm+mOOYNYUw3e2M1RA2ZmyvBQrdbRWAVFxaculGOJgXQvEhc5aGBBy0hwyh5ADSLczhBzit2o1KDmOCij1WA9k3rJqUCr7DN9+GMgMpB2KwwhCYtmbgYS8KSEGSns5hYCalr0ZiGzbSNhJj38ES4d6T71zT9XTRE+mCE+fsF/XZYcy4eyrAaEdMIfMIeQA0u0M/doh6U0txRAH66otK4dirijFsjZyVQFVA/kwKEcALOdTB16QMFM+B1B/tAAAAABJRU5ErkJggg==' transform='translate(-10 -10)' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E");
  }
}
.selectBg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
  > ul {
    width: 260px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    list-style: none;
    z-index: 9999;
    background: #fff;
    margin: 0;
    padding: 12px 16px;
    border: 1px solid #7e7e7e;
    border-radius: 6px;
    li {
      margin: 0;
      padding: 16px 0;
      border-bottom: 1px solid #fafafa;
      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
.order__footer {
  display: flex;
  padding: 14px 16px;
  align-items: center;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.08);
  p {
    margin-left: -8xp;
    text-align: center;
    flex: auto;
    margin: 0 0 0 -16px;
    padding: 0;
    font-size: 16px;
    font-weight: bold;
    color: #343434;
    width: 50%;
    span {
      color: #f2632a;
    }
  }
  button {
    width: 50%;
    background: #f2632a;
    line-height: 52px;
    padding: 0;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    color: #fff;
  }
}
.shahbet_profile_select {
  width: 100%;
  padding: 12px;
  border: 1px solid #d8d8d8;
  border-radius: 6px;
  background: #fff;
  font-size: 14px;
  color: #343434;
  margin-top: 10px;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 8l5 5 5-5' stroke='%23343434' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.order__shahbet__profile {
  padding: 30px 16px 0;
}

.order__shahbet__profile p {
  font-size: 14px;
  color: #343434;
  margin: 0 0 10px;
  padding: 0;
}
.order__content {
  padding: 30px 0;
  width: 100%;
  flex-grow: 1;
}
.mobile_wrap {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  > div {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
}
.order__receipt {
  padding: 0 16px 30px;
  p {
    font-size: 14px;
    color: #343434;
    padding: 0;
    margin: 0 0 10px;
  }
  dl {
    display: flex;
    margin: 0;
    dd {
      flex: auto;
      &:first-child {
        margin: 0 4px 0 0;
      }
      &:last-child {
        margin: 0 0 0 4px;
      }
      input {
        display: none;
      }
      input:checked + label {
        i {
          background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFF' d='M-56-505h360V638H-56z'/%3E%3Cg fill-rule='nonzero'%3E%3Cpath d='M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0z' fill='%23F2632A'/%3E%3Cpath d='M13.47 7.47a.75.75 0 011.133.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073L9 11.939l4.47-4.47z' fill='%23FFF'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }
      }
      label {
        justify-content: center;
        align-items: center;
        width: 100%;
        border: 1px solid #dedede;
        height: 50px;
        display: flex;
        border-radius: 6px;
        i {
          margin-right: 8px;
          background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFF' d='M-224-505h360V638h-360z'/%3E%3Cpath d='M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm4.53 5.97a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073L9 11.939l4.47-4.47a.75.75 0 011.06 0z' fill='%23D8D8D8' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E");
          width: 20px;
          height: 20px;
          background-size: cover;
          background-position: center;
        }
        span {
          font-size: 14px;
          color: #343434;
        }
      }
    }
  }
}
.star {
  color:#F2632A !important;
}
.agree__list {
  list-style: none;
  padding: 20px 0 0;
  margin: 0;
  li {
    padding: 20px 16px;
    border-bottom: 1px solid #f4f4f4;
    input {
      display: none;
    }
    input:checked + label {
      i {
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Crect fill='%23F2632A' width='20' height='20' rx='4'/%3E%3Cpath stroke='%23FFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' d='M6 9.5l2.5 3 5-5.5'/%3E%3C/g%3E%3C/svg%3E");
      }
    }
    label {
      font-size: 14px;
      color: #343434;
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        margin-right: 10px;
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Crect fill='%23F4F4F4' width='20' height='20' rx='4'/%3E%3Cpath stroke='%23C3C3C3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' d='M6 9.5l2.5 3 5-5.5'/%3E%3C/g%3E%3C/svg%3E");
      }
    }
  }
}
.coupon__select {
  padding: 0 16px 30px;
  p {
    font-size: 14px;
    color: #343434;
    margin: 0;
    padding: 0;
  }
  .coupon_select {
    margin-top: 10px;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    &.disabled {
      color: rgba(0, 0, 0, 0.38);
      border-color: rgba(0, 0, 0, 0.08);
      background: #fafafa;
      i {
        background-image: icon(angledown, "ebebeb");
      }
    }
    i {
      width: 20px;
      height: 20px;
      margin-left: auto;
    }
  }
}
.saved__money {
  p {
    margin-top: 10px;
    color: rgba(0, 0, 0, 0.38);
    span {
      color: #343434;
    }
  }
  .saved_money {
    display: flex;
    margin-top: 10px;
    input {
      border: 1px solid #d8d8d8;
      border-radius: 6px;
      padding: 12px;
      flex: 1;
      &::placeholder {
        color: rgba(0, 0, 0, 0.38);
      }
    }
    button {
      background: #fff;
      border: 1px solid #d8d8d8;
      margin-left: 8px;
      border-radius: 6px;
      padding: 0 10px;
      font-size: 12px;
    }
  }
}
.payment__select {
  padding: 0 16px 0;
  p {
    font-size: 14px;
    color: #343434;
    margin: 0;
    padding: 0;
  }
  .payment_select {
    margin-top: 10px;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    i {
      width: 20px;
      height: 20px;
      margin-left: auto;
    }
  }
  .payment__money {
    padding-top: 20px;
    dl {
      display: flex;
      justify-content: flex-end;
      margin: 0;
      padding: 0;
      dd {
        p {
          text-align: right;
          margin-right: 12px;
          font-size: 14px;
          color: #343434;
          padding-bottom: 4px;
          &:last-child {
            padding-bottom: 0px;
          }
        }
      }
      dt {
        p {
          text-align: right;
          font-size: 14px;
          padding-bottom: 4px;
          span {
            color: #f2632a;
            font-weight: bold;
          }
          &:last-child {
            padding-bottom: 0px;
          }
        }
      }
    }
  }
}
.delivery__info {
  padding: 0 16px 30px;
  
  .delivery__address dl{
    flex:1;
    width:100%;
    align-items: center;
    &:first-child{
      padding-top: 0;
    }
    dd:last-child{
      margin-left: 12px;
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      input{
        border: 1px solid #d8d8d8;
        border-radius: 6px;
        padding: 12px;
        width:100%;
      }
    }
  }
  dl {
    display: flex;
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #f4f4f4;
    &.delivery__price {
      padding-bottom: 20px;
      dd {
        &:last-child {
          font-size: 16px;
          span {
            color: #f2632a;
            font-weight: bold;
          }
        }
      }
    }
    dd {
      font-size: 14px;
      color: #343434;
      margin: 0;
      &:last-child {
        margin-left: auto;
      }
      button {
        background: #fff;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        padding: 6px 10px;
        font-size: 12px;
      }
    }
  }
  .delivery__address {
    font-size: 14px;
    color: #343434;
    background: #f4f4f4;
    border-radius: 6px;
    padding: 12px;
    word-break: keep-all;
    margin-bottom: 20px;
  }
}
.order__details {
  padding: 0 16px 30px;
  p {
    font-size: 14px;
    color: #343434;
    padding: 0;
    margin: 0 0 10px;
  }
  ul {
    padding: 0;
    margin: 0;
    background: #f4f4f4;
    border-radius: 6px;
    list-style: none;
    .product_name {
      font-size: 14px;
      font-weight: bold;
      color: #343434;
      padding: 12px;
      margin: 0;
      border-bottom: 1px solid #dedede;
    }
    li {
      margin: 0 12px;
      padding: 20px 0 0px;
      &:last-child {
        dl {
          border-bottom: 0;
        }
      }
      h3 {
        font-size: 14px;
        color: #343434;
        font-weight: bold;
        margin: 0;
      }
      dl {
        display: flex;
        flex-wrap: wrap;
        
        padding: 0 0 10px;
        margin: 0;
        justify-content: flex-end;
        border-bottom: 1px solid #dedede;
        dd {
          font-size: 14px;
          font-weight: 400;
          color: #343434;
          margin: 0;
          margin-left: 20px;
          display: flex;
          align-items: center;
          &:last-child {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
